<div (click)='toArticle()' class='related-article-item-wrapper'>
  <p>{{ relatedArticle.category }}</p>
  <img [src]='relatedArticle.coverImgUrl ?? defaultCoverImg' alt='cover-image' />
  <label>{{ relatedArticle.title }}</label>
</div>
